// Dependencies
import axios from 'axios';
import { format } from 'date-fns';
import { useSnackbar } from 'notistack';
import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
// Actions
import { updateStocksRoomBlackOut } from './redux/reducer';
import { setFinished } from '../utils/finished/redux/actions';
// Types
import { AppState } from '../../reducers';
import { intersection } from 'lodash';
import { BlackOut } from './objects/blackOut';
import { BlackOutData } from './objects/blackOutData';

const ChannelManagerStockClosedSaleSave: FC = (): null => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const client_id = useSelector((state: AppState) => state.header.client_id);
    const room_list = useSelector(
        (state: AppState) => state.channelManager.room_list
    );
    const channel_manager = useSelector(
        (state: AppState) => state.channelManager.channel_manager
    );
    const stocks_closed_sale_room_id = useSelector(
        (state: AppState) =>
            state.channelManager.stocks_closed_sale_room_id
    );
    const stocks_closed_sale_end_date = useSelector(
        (state: AppState) =>
            state.channelManager.stocks_closed_sale_end_date
    );
    const stocks_closed_sale_start_date = useSelector(
        (state: AppState) =>
            state.channelManager.stocks_closed_sale_start_date
    );
    const onSaveClosedSale = () => {
        if (
            channel_manager !== null &&
            stocks_closed_sale_room_id !== null &&
            stocks_closed_sale_start_date !== null &&
            stocks_closed_sale_end_date !== null
        ) {
            room_list.map((room) => {
                if (room.id === stocks_closed_sale_room_id) {
                    dispatch(setFinished(true));
                    let start_date: string =
                        stocks_closed_sale_start_date <=
                        stocks_closed_sale_end_date
                            ? new Date(
                                  stocks_closed_sale_start_date
                              ).toLocaleDateString('en-CA')
                            : new Date(
                                  stocks_closed_sale_end_date
                              ).toLocaleDateString('en-CA');
                    let end_date: string =
                        stocks_closed_sale_start_date <=
                        stocks_closed_sale_end_date
                            ? new Date(
                                  stocks_closed_sale_end_date
                              ).toLocaleDateString('en-CA')
                            : new Date(
                                  stocks_closed_sale_start_date
                              ).toLocaleDateString('en-CA');

                    const room_black_outs = room.black_out.map(
                        (black_out, black_out_index) => ({
                            start_date: new Date(
                                black_out?.start_date ||  black_out?.date || ''
                            ).toLocaleDateString('en-CA'),
                            end_date: new Date(
                                black_out?.end_date ||  black_out?.start_date ||  black_out?.date || ''
                            ).toLocaleDateString('en-CA'),
                            id: black_out_index
                        })
                    );
                    const black_outs = room_black_outs.map(
                        ({ start_date, end_date }) => ({
                            start_date,
                            end_date
                        })
                    );

                    let isIntersection_idCheckers: number[] = [];

                    room_black_outs.forEach((black_out) => {
                        if (
                            black_out.start_date <= start_date &&
                            black_out.end_date >= start_date
                        ) {
                            isIntersection_idCheckers.push(black_out.id);
                        }
                        if (
                            black_out.start_date <= end_date &&
                            black_out.end_date >= end_date
                        ) {
                            isIntersection_idCheckers.push(black_out.id);
                        }
                    });

                    let isOpeningSale = false;
                    let result: (BlackOutData | null)[] = [];
                    if (isIntersection_idCheckers.length === 0) {
                        black_outs.forEach((black_out) => {
                            if (
                                black_out.start_date >= start_date &&
                                black_out.start_date <= end_date &&
                                black_out.end_date <= end_date &&
                                black_out.end_date >= start_date
                            ) {
                                isOpeningSale = true;
                            }
                        });

                        result = isOpeningSale
                            ? black_outs.map((black_out) => {
                                  if (
                                      black_out.start_date >= start_date &&
                                      black_out.start_date <= end_date &&
                                      black_out.end_date <= end_date &&
                                      black_out.end_date >= start_date
                                  ) {
                                      return null;
                                  } else return black_out;
                              })
                            : [
                                  ...black_outs,
                                  {
                                      start_date,
                                      end_date
                                  }
                              ];
                    }

                    if (isIntersection_idCheckers.length === 1) {
                        isOpeningSale = true;
                        room_black_outs.forEach((black_out) => {
                            if (
                                black_out.start_date <=
                                    new Date(
                                        stocks_closed_sale_start_date
                                    ).toLocaleDateString('en-CA') &&
                                black_out.end_date >=
                                    new Date(
                                        stocks_closed_sale_start_date
                                    ).toLocaleDateString('en-CA')
                            ) {
                                isOpeningSale = false;
                            }
                        });
                        let newBlackOut: BlackOutData;
                        if (isOpeningSale) {
                            let from;
                            let to;
                            if (
                                start_date >=
                                room_black_outs[isIntersection_idCheckers[0]]
                                    .start_date
                            ) {
                                from =
                                    room_black_outs[
                                        isIntersection_idCheckers[0]
                                    ].start_date;
                                to = new Date(start_date);
                                to.setDate(to.getDate() - 1);
                                to = to.toLocaleDateString('en-CA');
                            } else {
                                from = new Date(end_date);
                                from.setDate(from.getDate() + 1);
                                from = from.toLocaleDateString('en-CA');
                                to =
                                    room_black_outs[
                                        isIntersection_idCheckers[0]
                                    ].end_date;
                            }
                            newBlackOut = { start_date: from, end_date: to };

                            result = black_outs.map((black_out) => {
                                if (
                                    black_out.start_date >= start_date &&
                                    black_out.start_date <= end_date &&
                                    black_out.end_date <= end_date &&
                                    black_out.end_date >= start_date
                                ) {
                                    return null;
                                } else return black_out;
                            });
                        } else {
                            newBlackOut = {
                                start_date:
                                    room_black_outs[
                                        isIntersection_idCheckers[0]
                                    ].start_date <= start_date
                                        ? room_black_outs[
                                              isIntersection_idCheckers[0]
                                          ].start_date
                                        : start_date,
                                end_date:
                                    room_black_outs[
                                        isIntersection_idCheckers[0]
                                    ].end_date >= end_date
                                        ? room_black_outs[
                                              isIntersection_idCheckers[0]
                                          ].end_date
                                        : end_date
                            };

                            result = [...black_outs];
                        }
                        isIntersection_idCheckers.forEach((index) => {
                            result?.splice(index, 1);
                        });
                        result = result.map((black_out) => {
                            if (
                                black_out &&
                                black_out.start_date >=
                                    newBlackOut.start_date &&
                                black_out.start_date <= newBlackOut.end_date &&
                                black_out.end_date <= newBlackOut.end_date &&
                                black_out.end_date >= newBlackOut.start_date
                            ) {
                                return null;
                            } else return black_out;
                        });
                        result.push(newBlackOut);
                    }

                    if (isIntersection_idCheckers.length === 2) {
                        let newBlackouts: BlackOutData[] = [];
                        if (
                            isIntersection_idCheckers[0] ===
                            isIntersection_idCheckers[1]
                        ) {
                            let from = new Date(start_date);
                            from.setDate(from.getDate() - 1);

                            let to = new Date(end_date);
                            to.setDate(to.getDate() + 1);
                            if (
                                from.toLocaleDateString('en-CA') >=
                                black_outs[isIntersection_idCheckers[0]]
                                    .start_date
                            )
                                newBlackouts.push({
                                    start_date:
                                        black_outs[isIntersection_idCheckers[0]]
                                            .start_date,
                                    end_date: from.toLocaleDateString('en-CA')
                                });
                            if (
                                to.toLocaleDateString('en-CA') <=
                                black_outs[isIntersection_idCheckers[0]]
                                    .end_date
                            )
                                newBlackouts.push({
                                    start_date: to.toLocaleDateString('en-CA'),
                                    end_date:
                                        black_outs[isIntersection_idCheckers[0]]
                                            .end_date
                                });
                            result = black_outs.map((black_out) => {
                                if (
                                    black_out.start_date >= start_date &&
                                    black_out.start_date <= end_date &&
                                    black_out.end_date <= end_date &&
                                    black_out.end_date >= start_date
                                ) {
                                    return null;
                                } else return black_out;
                            });
                            result?.splice(isIntersection_idCheckers[0], 1);
                        } else {
                            let from =
                                black_outs[isIntersection_idCheckers[0]]
                                    .start_date <
                                black_outs[isIntersection_idCheckers[1]]
                                    .start_date
                                    ? black_outs[isIntersection_idCheckers[0]]
                                          .start_date
                                    : black_outs[isIntersection_idCheckers[1]]
                                          .start_date;
                            let to =
                                black_outs[isIntersection_idCheckers[0]]
                                    .end_date >
                                black_outs[isIntersection_idCheckers[1]]
                                    .end_date
                                    ? black_outs[isIntersection_idCheckers[0]]
                                          .end_date
                                    : black_outs[isIntersection_idCheckers[1]]
                                          .end_date;
                            newBlackouts.push({
                                start_date: from,
                                end_date: to
                            });
                            result = result.map((black_out) => {
                                if (
                                    black_out &&
                                    black_out.start_date >=
                                        newBlackouts[0].start_date &&
                                    black_out.start_date <=
                                        newBlackouts[0].end_date &&
                                    black_out.end_date <=
                                        newBlackouts[0].end_date &&
                                    black_out.end_date >=
                                        newBlackouts[0].start_date
                                ) {
                                    return null;
                                } else return black_out;
                            });
                            isIntersection_idCheckers.forEach((index) => {
                                result?.splice(index, 1);
                            });
                        }

                        result = [...result, ...newBlackouts];
                    }

                    result = result?.filter((element) => element !== null);

                    axios({
                        method: 'PATCH',
                        url: `${API_HREF}client/${client_id}/custom-accommodations/${channel_manager.id}/rooms/${stocks_closed_sale_room_id}/`,
                        headers: {
                            Authorization: `Token ${localStorage.getItem(
                                'token'
                            )}`,
                            Accept: 'application/json',
                            'Content-Type': 'application/json'
                        },
                        data: {
                            black_out: result
                        }
                    })
                        .then((response) => {
                            enqueueSnackbar(
                                t('manual-accommodation.room-patch-success'),
                                { variant: 'success' }
                            );
                            dispatch(updateStocksRoomBlackOut(response.data));
                            dispatch(setFinished(false));
                        })
                        .catch((error) => {
                            if (error.response) {
                                if (error.response.status === 400) {
                                    // dispatch(setErrors(error.response.data));
                                    for (const [key, value] of Object.entries(
                                        error.response.data
                                    )) {
                                        if (Array.isArray(value)) {
                                            value.map((error) =>
                                                enqueueSnackbar(
                                                    `${key} : ${error}`,
                                                    { variant: 'error' }
                                                )
                                            );
                                        } else {
                                            enqueueSnackbar(
                                                `${key} : ${value}`,
                                                { variant: 'error' }
                                            );
                                        }
                                    }
                                } else if (
                                    error.response.status === 401 ||
                                    error.response.status === 403
                                ) {
                                    enqueueSnackbar(t('errors.permissions'), {
                                        variant: 'error'
                                    });
                                } else if (error.response.status === 500) {
                                    enqueueSnackbar(t('errors.servers'), {
                                        variant: 'error'
                                    });
                                }
                            } else if (error.request) {
                                console.log('error.request : ', error.request);
                            } else {
                                console.log('Error', error.message);
                            }
                            console.log('error.config : ', error.config);
                            dispatch(setFinished(false));
                        });
                }
            });
        }
    };
    useEffect(() => {
        onSaveClosedSale();
    }, [stocks_closed_sale_end_date, stocks_closed_sale_start_date]);
    return null;
};

export default ChannelManagerStockClosedSaleSave;
